const EMAIL_FIELDS = ['email', 'misEmail'];
const PHONE_FIELDS = ['phone', 'misPhone'];

function getContactSearchValue(clause: any, fields: string[]): any | undefined {
  const alternatives = clause && Array.isArray(clause.$or) ? clause.$or : [];
  if (alternatives.length === 0) return undefined;

  const fieldNames = alternatives.map(alternative => Object.keys(alternative || {})[0]);
  if (!fieldNames.every(field => fields.includes(field))) return undefined;

  const preferred = alternatives.find(alternative => typeof alternative[fields[0]] !== 'undefined');
  return preferred ? preferred[fields[0]] : alternatives[0][fieldNames[0]];
}

/**
 * School user endpoints use flat pseudo-fields for contact searches. This keeps
 * characters such as "+" and "@" intact and lets the backend apply the same
 * condition to the primary and MIS contact fields.
 */
export function normalizeSchoolUserContactSearchWhere(where: any = {}): any {
  const normalized = { ...where };

  const topLevelEmail = getContactSearchValue(normalized, EMAIL_FIELDS);
  const topLevelPhone = getContactSearchValue(normalized, PHONE_FIELDS);
  if (typeof topLevelEmail !== 'undefined') {
    normalized.emailSearch = topLevelEmail;
    delete normalized.$or;
  } else if (typeof topLevelPhone !== 'undefined') {
    normalized.phoneSearch = topLevelPhone;
    delete normalized.$or;
  }

  if (Array.isArray(normalized.$and)) {
    normalized.$and = normalized.$and.filter(clause => {
      const emailSearch = getContactSearchValue(clause, EMAIL_FIELDS);
      if (typeof emailSearch !== 'undefined') {
        normalized.emailSearch = emailSearch;
        return false;
      }

      const phoneSearch = getContactSearchValue(clause, PHONE_FIELDS);
      if (typeof phoneSearch !== 'undefined') {
        normalized.phoneSearch = phoneSearch;
        return false;
      }

      return true;
    });

    if (normalized.$and.length === 0) delete normalized.$and;
  }

  return normalized;
}

export function normalizeSchoolUserSearchFilter(filter: any = {}): any {
  if (!filter || typeof filter.where === 'undefined') return filter;
  return {
    ...filter,
    where: normalizeSchoolUserContactSearchWhere(filter.where)
  };
}
